import Model from 'models/Model'
import { isDevelopment } from 'helpers/env'

export const HS = 'HS'
export const HS_LABEL = 'Getting Started'

export const FAQ = 'FAQ'
export const FAQ_LABEL = 'Frequently Ask Question'

export const CATEGORY_TYPES = [
  { value: HS, label: HS_LABEL },
  { value: FAQ, label: FAQ_LABEL },
]

export default class Category extends Model {
  iconFile = null

  get id() {
    return this.model.id
  }

  get title() {
    return this.model.title
  }

  get description() {
    return this.model.description
  }

  get type() {
    return this.model.type
  }

  get iconName() {
    return this.model.icon
  }

  get iconUrl() {
    if (isDevelopment()) {
      return 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTRFSON25udfPbHH_w34if2f0E5aMOYMQV5ug&usqp=CAU'
    }

    if (this.iconFile) {
      return URL.createObjectURL(this.iconFile)
    }

    return null
  }
}
